{
    "welcomeMessage": "Bienvenue sur la Enterprise Tax Platform. Cette page contiendra un manuel au cas où vous n'auriez pas sélectionné de projet :)",
    "signIn": "Connexion",
    "leverageBetter": "Mieux tirer parti",
    "login": "S'identifier",
    "loginProblem": "Un problème de connexion?"
  }